export default __webpack_public_path__ + "static/media/parallax-bg29.d0fedf63.jpg";